import { Directive, HostBinding, Input, OnChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

/**
 * Un campo con `ngModel` es inválido cuando la página lo dice: `[appInvalidWhen]="submitted && !name"`.
 *
 * Ionic muestra el `errorText` de `ion-input`, `ion-textarea` e `ion-select` con las clases
 * `ion-touched` + `ion-invalid`, y además cablea `aria-invalid` y `aria-describedby`. Esas
 * clases las copia de las `ng-*` de Angular en cada cambio (`setIonicClasses` de
 * `@ionic/angular`): ponerlas a mano con `[class.ion-invalid]` no sirve, porque el próximo
 * cambio las borra. Con un validador, la validez sale de la página y Ionic la sigue sola.
 *
 * `app-invalid` en el elemento sirve para encontrar el primer campo con error y llevarlo a la
 * vista, sin esperar el cuadro de animación en el que Ionic pone sus clases.
 */
@Directive({
  selector: '[appInvalidWhen]',
  providers: [{ provide: NG_VALIDATORS, useExisting: InvalidWhenDirective, multi: true }],
  standalone: false
})
export class InvalidWhenDirective implements Validator, OnChanges {
  @Input() appInvalidWhen: boolean | null | undefined = false;

  private changed?: () => void;

  @HostBinding('class.app-invalid')
  get invalid(): boolean {
    return !!this.appInvalidWhen;
  }

  ngOnChanges(): void {
    this.changed?.();
  }

  validate(_control: AbstractControl): ValidationErrors | null {
    return this.invalid ? { invalid: true } : null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.changed = fn;
  }
}
